import { motion } from 'framer-motion';

import { Skeleton, Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

const MStack = motion.create(Stack);

export const AppointmentsLoader = () => {
  const { t } = useTranslation();
  return (
    <MStack
      align="center"
      justify="center"
      gap={4}
      className="pointer-events-none size-full rounded-lg bg-bg-primary/80 backdrop-blur-xs"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: 0.2 }}
    >
      <Text color="supporting" className="ml-16">
        {t('home.loader.loadingAppointments')}
      </Text>
      <Stack className="max-w-[320px]" gap={0}>
        {[0, 0.8, 1.6].map((delay, index) => (
          <motion.div
            className="flex h-14 w-full gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay,
            }}
            key={index}
          >
            <Skeleton className="h-4 w-16 bg-border-primary" />
            <div className="h-full w-[1.5px] bg-border-primary" />
            <Skeleton className="h-10 w-full bg-border-primary py-2" />
          </motion.div>
        ))}
      </Stack>
    </MStack>
  );
};
